module.exports = __webpack_public_path__ + "static/media/settings.7c38b4ff.svg";